var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col bg-white shadow-sm hover:shadow-xl mb-5 transition delay-75 duration-200 ease-in-out rounded-xl",
      class: _vm.optionalClasses,
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-10 bg-gray-50 flex rounded-xl pl-4 font-bold items-center text-semibold space-x-4 justify-end mr-2 relative",
        },
        [_vm._t("header")],
        2
      ),
      _c(
        "div",
        { staticClass: "flex w-full p-4 flex-wrap", class: _vm.bgClasses },
        [_vm._t("default")],
        2
      ),
      _vm.$scopedSlots.footer
        ? _c(
            "div",
            {
              staticClass:
                "flex w-full justify-end items-center border-t border-opacity-5 h-16",
              class: _vm.actionBarStyles,
            },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }